import { jsx as _jsx } from "react/jsx-runtime";
import { Typography } from '@mui/material';
export const DialogTitleEntityId = ({ children }) => {
    return (_jsx(Typography, { variant: "h5", sx: ({ palette }) => ({ ml: 4, color: palette.text.muted, lineHeight: '1.7rem' }), children: children }));
};
